import { render, staticRenderFns } from "./dui-radio-group.vue?vue&type=template&id=0087c4c7&scoped=true&"
import script from "./dui-radio-group.vue?vue&type=script&lang=js&"
export * from "./dui-radio-group.vue?vue&type=script&lang=js&"
import style0 from "./dui-radio-group.vue?vue&type=style&index=0&id=0087c4c7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0087c4c7",
  null
  
)

export default component.exports